export default {
  DE: {
    name: 'Germany',
    phone_code: '+49'
  },
  AT: {
    name: 'Austria',
    phone_code: '+43'
  },
  CH: {
    name: 'Switzerland',
    phone_code: '+41'
  }
};
